import React from 'react';

type Props = {
  src: string | null;
};

export function LoadingGif({ src }: Props) {
  if (!src) return null;
  return <img src={src} alt='Loading...' style={{ maxHeight: 900 }} />;
}
